import gql from 'graphql-tag';
import { AdminCmsListItem } from '../fragments';

export default gql`
mutation createCmsContent (
    $title: String!
    $content: String
    $is_active: Boolean!
    $active_from: DateTime
    $active_to: DateTime
    $url_key: String!
    $meta_title: String
    $meta_keywords: String
    $meta_description: String
) {
    createCmsContent (input: {
        title: $title
        content: $content
        is_active: $is_active
        active_from: $active_from
        active_to: $active_to
        url_key: $url_key
        meta_title: $meta_title
        meta_keywords: $meta_keywords
        meta_description: $meta_description
    }) {
        ...AdminCmsListItem
    }
}
${AdminCmsListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createCmsContent.ts